import { requireNativeViewManager } from 'expo-modules-core';
import { View } from 'react-native';

export const NativeBlurView = requireNativeViewManager('ExpoBlur', 'ExpoBlurView');

export const NativeBlurTargetView = View;
